export const getVersionOfPortal = (possibleAlternativeVersions: string[], url?: string) => {
    const regex = /-(\w)(?=\/|$)/;
    const match = url?.replace(/#.*/, '').match(regex);

    if (match) {
        const [, version] = match;
        const isSuchVersionExist = possibleAlternativeVersions.includes(version);

        return isSuchVersionExist ? `${version}-link` : '';
    }
};
